// import { CuratorInfoIcon } from '../components/admin/curator/CuratorInfoIcon/CuratorInfoIcon';
// import { InfoFilledIcon } from '../components/icons/InfoFilledIcon';
import {
  ON_BOARDING_ROUTE,
  PRIVACY_POLICY_ROUTE,
  REQUESTS_ROUTE_PDP,
  REQUESTS_ROUTE_PDP_DETAIL,
  RETAIL_CONFIGURATOR_ROUTE,
  RETAIL_CONFIGURATOR_VIEWER_ROUTE,
  SLA_AGREEMENT_ROUTE,
  TERMS_OF_USE_ROUTE,
  TUTORIALS_ROUTE,
} from '../constants/routePathConstants';
import { checkIfEmailIsVerifiedOrNot, useUserContext } from '../contexts/UserContext';

import { HIDE_SECTION } from '../constants/constants';
import cx from 'classnames';
import icons from './../assets/icons';
import { isConfiguratorView, isRetailAutomation } from '../components/Configurator/utils';
// import { getLocalStorage } from '../helpers/jsHelper';
import { isCuratorPage } from '../helpers/urlHelper';
import { openTutorialVideoModal } from '../components/learn/LearnVideoModel';
import { selectVideo } from '../redux/slicers/learnByVideoSlicer';
// import { CURATOR_ROUTES, PREVIEW_ROUTES } from '../routes';
import styles from './../components/admin/curator/CuratorInfoIcon/CuratorInfoIcon.module.scss';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { REQUESTS_ROUTE } from '../config/constant/routePathConstant';
import { setPlayRequestVideo } from '../redux/slicers/requestSlicer';
import { dispatcher } from '../helpers/projectHelper';
import { Overlay, Tooltip } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import { selectIsChatBotAvailable } from '../redux/slicers/activitySlicer';

const { PlayIcon } = icons;

const EXCLUDED_ROUTES = [
  TERMS_OF_USE_ROUTE,
  PRIVACY_POLICY_ROUTE,
  SLA_AGREEMENT_ROUTE,
  TUTORIALS_ROUTE,
  REQUESTS_ROUTE, // hiding it as we are showing the frappe iframe on request page
  RETAIL_CONFIGURATOR_ROUTE,
  RETAIL_CONFIGURATOR_VIEWER_ROUTE,
  REQUESTS_ROUTE_PDP,
];

export const PortalInfoIcon = () => {
  const location = useLocation();
  const requestOverlay = useRef(null);
  const { currentUser } = useUserContext();
  const onboardingState = location.pathname.includes(ON_BOARDING_ROUTE);
  const isRequestPage = () => location.pathname.includes(REQUESTS_ROUTE);
  const isTutorialVideoAvailable = useSelector(selectVideo);
  const isVideoAvailable = isRequestPage() || isTutorialVideoAvailable;
  const isChatBotAvailable = useSelector(selectIsChatBotAvailable);
  const [showTooltip, setShowTooltip] = useState(false);

  const openVideo = () =>
    isRequestPage() ? dispatcher(setPlayRequestVideo(true)) : openTutorialVideoModal();

  useEffect(() => {
    let timerId = null;
    if (isRequestPage() && !currentUser?.user?.other_info?.isRequestVideoPlayed) {
      timerId = setTimeout(() => setShowTooltip(true), 1000);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
        setShowTooltip(false);
      }
    };
  }, [currentUser, location.pathname]);

  // Check if current path matches PDP detail route pattern (e.g., /requests/pdp/123)
  const isPdpDetailRoute = location?.pathname?.startsWith(REQUESTS_ROUTE_PDP_DETAIL.replace(':id', ''));

  const shouldHideComponent =
    !currentUser?.id ||
    onboardingState ||
    isCuratorPage() ||
    isConfiguratorView() ||
    isRetailAutomation() ||
    EXCLUDED_ROUTES.includes(location?.pathname) ||
    isPdpDetailRoute ||
    HIDE_SECTION.some((url) => (location?.pathname?.match(url)?.length ? true : false));

  // const excludeRoutes = [...PREVIEW_ROUTES, ...CURATOR_ROUTES];
  // const match = excludeRoutes.find((path) => matchPath({ path }, location.pathname) !== null);
  // if (match) return null;

  // return <CuratorInfoIcon doHide={'Keyboard shortcuts'} className={'keepOnTop'} />;

  if (shouldHideComponent || !isVideoAvailable) return null;

  return (
    <>
      <div
        onMouseEnter={() => setShowTooltip(isRequestPage())}
        onMouseLeave={() => setShowTooltip(false)}
        ref={requestOverlay}
        className={cx(styles.root, isChatBotAvailable ? styles.moveIconToLeftSide : '')}
        style={!checkIfEmailIsVerifiedOrNot(false) ? { bottom: '3.05rem' } : {}}>
        <PlayIcon className={styles.infoIcon} onClick={openVideo} />
      </div>
      <Overlay target={requestOverlay?.current} show={showTooltip} placement="top">
        {(props) => <Tooltip {...props}>How to make a Request?</Tooltip>}
      </Overlay>
    </>
  );
};
